import { authHeader } from '../../_helpers';
import axios from 'axios';

export const HomePageService = {
    addOrgHandler,
    getOrgHandler,
    getCountryListHandler
}

axios.defaults.headers.common = authHeader();
let token = localStorage.getItem('access_token')

function addOrgHandler(data) {
    const fd = {
        'country':data.data.country_id,
        'organisation_name':data.data.org_name
    }
    return axios.post(`/analytics/organisation/create/list/?access_token=${token}`,fd)
        .then(response => {
            return response;
        });
}

function getOrgHandler() {
    return axios.get(`/analytics/organisation/create/list/?access_token=${token}`)
        .then(response => {
            return response;
        });
}

function getCountryListHandler() {
    return axios.get(`/masters/country/list/?access_token=${token}`)
        .then(response => {
            return response;
        });
}


// WEBPACK FOOTER //
// ./src/_services/HomePage/homePage.service.js